import axios from 'axios'
const request = axios.create({
  baseURL: 'https://wisdom.jsc1319.com/',
  timeout: 5000
})

export default request
